import React, {useEffect, useState} from 'react';
import {FiAlertCircle, FiChevronRight, FiEdit, FiEye, FiHome, FiTrash} from "react-icons/fi";
import {useTranslation} from "react-i18next";
import cx from 'classnames';
import 'moment/locale/fr';
import Modal from "../components/Modal";
import {createUser, deleteUser, getAllUsers, updateUser} from "../servicesV2/usersService";
import {useForm} from "react-hook-form";

function DeleteModal({close, initData, fetchClients}){

  const {t} = useTranslation();

  const submit = async ()=>{
    await deleteUser(initData.id)
      .then((res)=>{
        fetchClients();
        close();
      })
      .catch((err)=> console.log(err) );
  }

  return(
    <div className='flex flex-col items-center' >
      <FiAlertCircle size={64} color='#D6323A' />
      <p className='mt-4 font-bold text-lg' >{t("USERS.DELETE_MODAL.TITLE")}</p>

      <div className='w-full mt-6 flex items-center justify-between px-10' >
        <button onClick={()=> close() } className='hover:text-azure hover:border-azure flex items-center gap-2 px-2.5 py-1.5 rounded-lg border text-xs font-semibold text-gray-600' >
          {t("GLOBAL.CANCEL")}
        </button>
        <button onClick={()=> submit() } className='flex items-center gap-2 px-2.5 py-1.5 rounded-lg border border-azure bg-azure text-xs font-semibold text-white hover:shadow-lg' >
          {t("GLOBAL.DELETE")}
        </button>
      </div>
    </div>
  )
}

function UserModal({close, initData, fetchClients}){

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: {errors}
  } = useForm({
    FullName: "",
    Email: "",
    isActive: true
  });

  const onSubmit = async (data)=>{

    setLoading(true);

    try {
      if(initData){
        const res = await updateUser(data, initData.id);
        if(res){
          fetchClients();
          close();
          console.log(res);
        }
      }else{
        const res = await createUser(data);
        if(res){
          fetchClients();
          close();
          console.log(res);
        }
      }
    } catch(err){
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    if(initData){
      reset(initData);
    }
  }, [initData])

  return(
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
        <div className='flex flex-col col-span-2'>
          <div className='px-2.5 mb-0.5 flex items-center justify-between'>
            <label className='text-xs text-gray-500 font-semibold'>{t("USERS.TABLE.NOM")} *</label>
            {errors.FullName &&
              <label className='text-xs text-red-700 font-semibold'>{t("GLOBAL.REQUIRED_ERROR")}</label>
            }
          </div>
          <input
            className='border rounded-lg px-2 py-1.5 text-sm'
            placeholder={t("USERS.TABLE.NOM")}
            {...register("FullName", {required: true})}
          />
        </div>
        <div className='flex flex-col col-span-2'>
          <div className='px-2.5 mb-0.5 flex items-center justify-between'>
            <label className='text-xs text-gray-500 font-semibold'>{t("USERS.TABLE.EMAIL")} *</label>
            {errors.Email &&
              <label className='text-xs text-red-700 font-semibold'>{t("GLOBAL.REQUIRED_ERROR")}</label>
            }
          </div>
          <input
            className='border rounded-lg px-2 py-1.5 text-sm'
            placeholder={t("USERS.TABLE.EMAIL")}
            {...register("Email", {required: true})}
          />
        </div>
        <div className='flex flex-col col-span-2'>
          <div className='px-2.5 mb-0.5 flex items-center justify-between'>
            <label className='text-xs text-gray-500 font-semibold'>{initData ? t("USERS.TABLE.NEW_PASSWORD") : t("USERS.TABLE.PASSWORD") }</label>
            {errors.password &&
              <label className='text-xs text-red-700 font-semibold'>{t("GLOBAL.REQUIRED_ERROR")}</label>
            }
          </div>
          <input
            className='border rounded-lg px-2 py-1.5 text-sm'
            placeholder={initData ? t("USERS.TABLE.NEW_PASSWORD") : t("USERS.TABLE.PASSWORD") }
            {...register("password", {required: !initData})}
          />
        </div>

        <div className="mt-8" >
          {
            loading ? (
              <div className="relative border border-azure px-4 py-2 h-9 w-24 rounded-lg">
                <div className="loader"/>
              </div>
            ) : (
              <button
                className="cursor-pointer bg-azure px-4 py-2 text-sm font-semibold rounded-lg text-white hover:opacity-60 hover:shadow">
                {t("GLOBAL.SAVE")}
              </button>
            )
          }
        </div>
      </form>
    </div>
  )
}

function Users() {

  const {t} = useTranslation();

  const [clients, setClients] = useState([]);

  const [isDeleteClientModalOpen, setIsDeleteClientModalOpen] = React.useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = React.useState(false);
  const [modalData, setModalData] = useState(null);

  const openUserModal = (clientId) => {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setIsUserModalOpen(true);

    if (clientId) {
      setModalData(clientId)
    }
  }
  const closeUserModal = () => {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    setIsUserModalOpen(false);
    setModalData(null);
  }

  const openDeleteClientModal = (clientId) => {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setModalData(clientId)
    setIsDeleteClientModalOpen(true);
  }
  const closeDeleteClientModal = () => {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    setIsDeleteClientModalOpen(false);
    setModalData({});
  }

  const fetchClients = async ()=>{
    await getAllUsers()
      .then((res)=> {
        setClients(res);
      })
      .catch((err)=>console.log(err));
  }

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <div>
      <div className="text-gray-500 flex items-center gap-2 mt-2 mb-6">
        <span className="text-xs font-semibold flex items-center">
          <FiHome size={12}/> <FiChevronRight size={12}/>
        </span>
        <h4 className="text-xs font-semibold text-gray-500">{t("ROOT.NAV.CLIENTS")}</h4>
      </div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold">{t("CLIENTS.TITLE")}</h1>
        <button
          onClick={()=> openUserModal() }
          className="cursor-pointer bg-azure px-4 py-2 text-sm font-semibold rounded-lg text-white hover:opacity-60 hover:shadow"
        >
          {t("CLIENTS.ADD_BTN")}
        </button>
      </div>
      <div className="bg-white p-0 rounded-lg customShadow">
        <table className="min-w-full border-collapse" id='my-applications-table'>
          <thead className="bg-gray-100 customShadow">
          <tr>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("USERS.TABLE.NOM")}</th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("USERS.TABLE.EMAIL")}</th>
            {/*<th className="text-left py-3 px-2 uppercase font-semibold text-xs">{t("USERS.TABLE.STATUS")}</th>*/}
            <th/>
          </tr>
          </thead>
          <tbody className="text-gray-800 text-sm ">
          {
            clients.map((it) =>
              <tr key={it.id} className={cx('border')}>
                <td className="text-left py-3 px-2">{it.FullName}</td>
                <td className="text-left py-3 px-2">{it.Email}</td>
                {/*<td className="text-left py-3 px-2">{it.isActive}</td>*/}
                <td className='w-20'>
                  <div className='flex items-center gap-4'>
                    <button onClick={()=> openUserModal(it) } >
                      <FiEdit size={16} className='hover:text-azure cursor-pointer text-yellow-500' />
                    </button>
                    <FiTrash
                      onClick={() => openDeleteClientModal(it)}
                      size={16}
                      className='hover:text-red-700 cursor-pointer text-red-600'
                    />
                  </div>
                </td>
              </tr>
            )
          }
          </tbody>
        </table>
      </div>

      <Modal isOpen={isDeleteClientModalOpen} close={closeDeleteClientModal} title="Supprimer le Client" >
        <DeleteModal close={closeDeleteClientModal} initData={modalData} fetchClients={fetchClients} />
      </Modal>
      <Modal isOpen={isUserModalOpen} close={closeUserModal} title={modalData ? "Modifier" : "Ajouter"} >
        <UserModal close={closeUserModal} initData={modalData} fetchClients={fetchClients} />
      </Modal>
    </div>
  );
}

export default Users;
